import { Component, OnInit,ViewChild } from '@angular/core';
import { BillingService } from '../../../services-http/billing/billing.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-cancellation-notice',
  templateUrl: './cancellation-notice.component.html',
  styleUrls: ['./cancellation-notice.component.scss']
})
export class CancellationNoticeComponent implements OnInit {
   @ViewChild('cancellationModal') cancellationModal: ModalDirective;
  


  constructor(
    private bill:BillingService,
    private spinner: NgxSpinnerService
  ) { }

    cancellationForm = new FormGroup({
      reason: new FormControl('', [Validators.required]),
      remarks: new FormControl('', [Validators.required]),
      policyno: new FormControl('', [Validators.required]),
      assured_name: new FormControl(''),
      date: new FormControl('')
    });

    filterForm = new FormGroup({
      date_from: new FormControl(''),
      date_to: new FormControl(''),
      product: new FormControl('')
    });

  productList = [
    { "varshortname": "STANDARD FIRE", "variantid": 1 },
    { "varshortname": "COMPREHENSIVE", "variantid": 2 },
    { "varshortname": "CTPL", "variantid": 3 },
    { "varshortname": "COOP AKSI", "variantid": 4 },
    { "varshortname": "FAMSI", "variantid": 5 },
    { "varshortname": "3sure Life", "variantid": 6 },
    { "varshortname": "KABAYANi", "variantid": 7 },
    { "varshortname": "MILLENNIALS PROTEK", "variantid": 8 },
    { "varshortname": "TODA PLAN", "variantid": 9 },
    { "varshortname": "LYSA", "variantid": 10 },
    { "varshortname": "LIFE AND HOME ASSURE", "variantid": 11 },
    { "varshortname": "MyPARENTS PROTEK", "variantid": 12 },
    { "varshortname": "DISABLITY LIFE ENSURE", "variantid": 13 },
    { "varshortname": "ANGELICA", "variantid": 55 },
    { "varshortname": "ADVANTAGE", "variantid": 56 },
    { "varshortname": "CHAIN", "variantid": 57 },
    { "varshortname": "CFP", "variantid": 58 },
    { "varshortname": "CSEINS", "variantid": 59 },
    { "varshortname": "FICA", "variantid": 60 },
    { "varshortname": "GADDDI-PLUS", "variantid": 61 },
    { "varshortname": "GRTL-INFINITY", "variantid": 62 },
    { "varshortname": "KEYMAN", "variantid": 63 },
    { "varshortname": "PATEXT15", "variantid": 64 },
    { "varshortname": "SAI", "variantid": 65 },
    { "varshortname": "TRAVEL-PA", "variantid": 66 },
    { "varshortname": "GLAFI", "variantid": 67 },
    { "varshortname": "FLI", "variantid": 68 },
    { "varshortname": "SURETY BOND", "variantid": 69 },
    { "varshortname": "WPID", "variantid": 70 },
    { "varshortname": "King-Protector", "variantid": 71 },
    { "varshortname": "KYS", "variantid": 72 },
    { "varshortname": "HEAL", "variantid": 73 },
    { "varshortname": "MOTORBANCA", "variantid": 74 }
  ]


  ngOnInit() {

    this.fetch_90days_unpaid_policies(1, false);
  }

  searchText: string = '';
  showReason: boolean = false;
  cancellationNotice: any = {
    data:[]
  }



  fetch_90days_unpaid_policies(page, exports){
    this.spinner.show();

    let data = {
      page: page,
      export: exports,
      date_from: this.filterForm.value.date_from,
      date_to: this.filterForm.value.date_to,
      product: this.filterForm.value.product
    }

    this.bill.get_90days_unpaid_policies(data).subscribe({
      next: (data:any) => {
        
        this.spinner.hide();
        if(exports){
          window.open(data);
        }else{
          this.cancellationNotice = data;
        }
      },
      error: (error) => {
        console.error('Error fetching 90 days unpaid policies:', error);
        this.spinner.hide();
      }
    });
  }


  subtractDays(date: string ): string {
    const d = new Date(date);
    d.setDate(d.getDate() + 120);
    return d.toISOString().split('T')[0];
  }

  getdaysLeft(date: string): number {
    const today = new Date();
    const targetDate = new Date(date);
    const timeDiff = targetDate.getTime() - today.getTime();
    return Math.ceil(Math.abs(timeDiff) / (1000 * 3600 * 24));
  }



  request_endorsement(){
    this.spinner.show();

    this.bill.request_endorsement(this.cancellationForm.value).subscribe(res => {

      this.spinner.hide();
      this.cancellationModal.hide();

      this.cancellationNotice.data = this.cancellationNotice.data.filter(
        (item: any) => item.policyno !== this.cancellationForm.value.policyno
      );

      Swal.fire({
        title: 'Success',
        text: 'Endorsement request created successfully!',
        type: 'success',
        confirmButtonText: 'OK'
      });

    },error => {
      console.error('Error requesting endorsement:', error);
      this.spinner.hide();

    });
  }


  cancelPolicy(row){
    this.cancellationModal.show();
    this.showReason=false

    this.cancellationForm.patchValue({
      policyno: row.policyno,
      reason: "This document confirms that "+row.assured_name +" agrees and understands that the policy will be cancelled as per issue because it has remained unpaid for more than 90 days.",
      remarks: 'cancel',
      assured_name: row.assured_name,
      date: row.pol_effective_date
    });
  }






}
